import React from "react";
import { Helmet } from "react-helmet";
import { FormattedMessage, useIntl } from "react-intl";
import { useSearchParams } from "react-router";
import { css } from "@emotion/react";
import backgroundImage from "assets/images/Faith-2000x1340-c-center.jpg";
import { LoginContainer } from "components/Login";
import { ResendConfirmationForm } from "components/Confirmation";
import { useQueryData } from "hooks";
import { GET_PUBLIC_USER } from "graphql/queries";
import { Spinner } from "components/Loader";
import { colors, fontSize } from "style";

/**
 * ResendConfirmation
 */
const ResendConfirmation = () => {
  const intl = useIntl();
  const selectedBanner = banners[0];
  const [searchParams] = useSearchParams();
  const id = searchParams.get("confirmation_token");
  const { data, loading } = useQueryData({
    queryName: GET_PUBLIC_USER,
    variables: { token: id },
    skip: !id,
  });
  const user = data?.publicUser || {};
  const { confirmed } = user;

  return (
    <>
      <Helmet>
        <title>{intl.formatMessage({ id: "Meta.ResendConfirmation.Title" })}</title>
      </Helmet>
      <LoginContainer banner={selectedBanner}>
        {loading ? (
          <Spinner />
        ) : confirmed ? (
          <span css={invalidLinkStyle}>
            <FormattedMessage id="Global.Link.Expired" values={{ action: "confirm", entity: "account" }} />
          </span>
        ) : (
          <ResendConfirmationForm />
        )}
      </LoginContainer>
    </>
  );
};

const invalidLinkStyle = css`
  line-height: normal;
  font-size: ${fontSize.large};
  color: ${colors.grayAnatomyBase2};
`;

const banners = [
  {
    title: "Gain access to exclusive opportunities and a network of top professionals.",
    label: "Faith Adekogbe",
    description: "Frontend Developer",
    cover: `url(${backgroundImage})`,
  },
];

export default ResendConfirmation;
